import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import './PopUp.css';
import image from '../../../components/Assets/img/misc/commingSoonedit2.png';
import { useTranslation } from 'react-i18next';
const ErrorRoutePage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const linkroute = useCallback(() => history.push('/'), [history]);
  return (
    <>
      <div className="popUpRoot">
        <div className="popUpBox">
          <div style={{ margin: '16px auto 50px auto' }}>{/* <h1></h1> */}</div>
          <img className="popUpImg" alt="" src={image} />
          <div style={{ margin: '40px 10% 50px 10%' }}>
            <h4 style={{ lineHeight: '40px' }}>
              {/* {"We are currently working on this feature and will launch soon!"} */}
              {t('sections-ErrorRoute-ErrorRoute-Wrongplanet')}
              <span onClick={linkroute}>
                {t('sections-ErrorRoute-ErrorRoute-click')}
              </span>
              {t('sections-ErrorRoute-ErrorRoute-homepage')}
            </h4>
          </div>
        </div>
      </div>
    </>
  );
};

// CommingSoonPopUp.propTypes = {
// };

export default ErrorRoutePage;
